import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

/** Giá trị hiệu lệnh mặc định — trùng với quy ước MC đang dùng trong phòng. */
const DEFAULT_START_KEYWORD = 'Bắt đầu chấm điểm';
const DEFAULT_END_KEYWORD = 'Kết thúc chấm điểm';

export default class RoomScoringPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            liveRoomId: '',
            startKeyword: DEFAULT_START_KEYWORD,
            endKeyword: DEFAULT_END_KEYWORD,
            mcUid: '',
            result: null,
            loading: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.calculate = this.calculate.bind(this);
        this.reset = this.reset.bind(this);
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    /** Format timestamp (ms) sang giờ Việt Nam cho dễ đối chiếu với log phòng. */
    formatTime(timestamp) {
        if (!timestamp) return '--';
        return new Date(timestamp).toLocaleString('vi-VN');
    }

    reset() {
        this.setState({
            liveRoomId: '',
            startKeyword: DEFAULT_START_KEYWORD,
            endKeyword: DEFAULT_END_KEYWORD,
            mcUid: '',
            result: null,
        });
    }

    calculate() {
        const { liveRoomId, startKeyword, endKeyword, mcUid } = this.state;

        // Backend nhận liveRoomId/mcUid kiểu số, gửi chuỗi sẽ lỗi parse.
        if (!/^\d+$/.test(liveRoomId.toString().trim())) {
            toast.warning('ID phòng phải là số.');
            return;
        }
        if (!/^\d+$/.test(mcUid.toString().trim())) {
            toast.warning('UID của MC phải là số.');
            return;
        }
        if (!startKeyword.trim() || !endKeyword.trim()) {
            toast.warning('Vui lòng nhập đủ hiệu lệnh bắt đầu và kết thúc.');
            return;
        }

        const requestData = {
            liveRoomId: Number(liveRoomId),
            startKeyword: startKeyword.trim(),
            endKeyword: endKeyword.trim(),
            mcUid: Number(mcUid),
        };

        this.setState({ loading: true });

        axios.post(
            global.config.apiDomain + '/mc-live-room/web/room-scoring/calculate',
            JSON.stringify(requestData),
            { headers: { 'Content-Type': 'application/json' } }
        ).then(res => {
            if (res.data.status === 'OK') {
                this.setState({ result: res.data.data, loading: false });
                toast.success('Tính điểm thành công!');
            } else {
                this.setState({ result: null, loading: false });
                toast.error('Tính điểm thất bại: ' + res.data.message);
            }
        }).catch(error => {
            console.error('Error calculating room scoring:', error);
            this.setState({ loading: false });
            toast.error('Có lỗi xảy ra khi tính điểm!');
        });
    }

    /** Bảng người tham gia — dùng chung cho cả danh sách hợp lệ và không hợp lệ. */
    renderUserTable(title, users, isValid) {
        const list = users || [];

        return (
            <div className="col-md-6">
                <h5 className={isValid ? 'text-success' : 'text-danger'}>
                    {title} ({list.length})
                </h5>
                <table className="table table-hover table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Tên người dùng</th>
                            <th scope="col">UID</th>
                            <th scope="col">Nội dung</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.length === 0 && (
                            <tr>
                                <td colSpan="4" className="text-center">Không có dữ liệu</td>
                            </tr>
                        )}
                        {list.map((user, index) => (
                            <tr key={user.userUid + '-' + index}>
                                <th scope="row">{index + 1}</th>
                                <td>{user.userName}</td>
                                <td>{user.userUid}</td>
                                <td>{user.message}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderResult() {
        const { result } = this.state;
        if (result == null) return null;

        return (
            <>
                <hr />
                <h4>Kết quả bình chọn</h4>
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <th style={{ width: '25%' }}>Điểm trung bình</th>
                            <td><strong>{result.averageScore}</strong></td>
                            <th style={{ width: '25%' }}>Tổng người tham gia</th>
                            <td>{result.totalParticipants}</td>
                        </tr>
                        <tr>
                            <th>Lượt hợp lệ</th>
                            <td className="text-success">{result.validCount}</td>
                            <th>Lượt không hợp lệ</th>
                            <td className="text-danger">{result.invalidCount}</td>
                        </tr>
                        <tr>
                            <th>Thời gian bắt đầu</th>
                            <td>{this.formatTime(result.startTime)}</td>
                            <th>Thời gian kết thúc</th>
                            <td>{this.formatTime(result.endTime)}</td>
                        </tr>
                    </tbody>
                </table>

                <div className="row">
                    {this.renderUserTable('Bình chọn hợp lệ', result.validUsers, true)}
                    {this.renderUserTable('Bình chọn không hợp lệ', result.invalidUsers, false)}
                </div>
            </>
        );
    }

    render() {
        const { liveRoomId, startKeyword, endKeyword, mcUid, loading } = this.state;

        return (
            <>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Bình chọn trực tiếp sự kiện</h1>
                        <hr />

                        <div className="row">
                            <div className="col-md-3 form-group">
                                <label>ID phòng sự kiện</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="liveRoomId"
                                    value={liveRoomId}
                                    onChange={this.handleChange}
                                    placeholder="VD: 6361406809112576"
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>UID của MC</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="mcUid"
                                    value={mcUid}
                                    onChange={this.handleChange}
                                    placeholder="UID người đưa ra hiệu lệnh"
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>Hiệu lệnh bắt đầu</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="startKeyword"
                                    value={startKeyword}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>Hiệu lệnh kết thúc</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="endKeyword"
                                    value={endKeyword}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <button
                                className="btn btn-primary mr-2"
                                onClick={this.calculate}
                                disabled={loading}
                            >
                                {loading ? 'Đang tính...' : 'Tính điểm'}
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={this.reset}
                                disabled={loading}
                            >
                                Nhập lại
                            </button>
                        </div>

                        {this.renderResult()}
                    </div>
                </div>
            </>
        );
    }
}
